<template>
    <div>
        <GoogleMap
            :api-key="googleMapsApiKey"
            :style="(view == 'fitters' || view == 'fittedNationally') ? 'width: 100%; height: 80vh;' : 'width: 100%; height: 300px;'"
            :center="center"
            :options="{}"
            :zoom="zoom"
            ref="mapRef"
            :streetViewControl="false"
            :fullscreenControl="false"
            :mapTypeControl="false"
            :styles='[{"featureType":"administrative.land_parcel","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","stylers":[{"visibility":"off"}]}]'
            @tilesloaded.once="onTilesLoaded"
        >
            <Marker
                :options="{
                    position: center,
                    icon: this.baseUrl + '/assets/icons/home.png' 
                }"
            />
            <Marker
                v-for="fitter in garageFitters"
                :key="fitter.id"
                :options="{
                    position: {
                        lat: parseFloat(fitter.latitude),
                        lng: parseFloat(fitter.longitude)
                    },
                    label: {
                        text: fitter.mapIconNumber,
                        color: fitter.mapIconColour,
                    },
                    title: fitter.name,
                    icon: fitter.mapIconSymbol,
                }"
                @click="viewFitter(fitter.id, fitter.latitude, fitter.longitude)"
            />
        </GoogleMap>
    </div>
</template>

<script>
    import { GoogleMap, Marker } from 'vue3-google-map';
    import google_map from '@shared/mixins/google_map';

    export default {
        props: ['googleMapsApiKey', 'postcodeDetails', 'fitters', 'view'],
        components: {GoogleMap, Marker},
        mixins: [google_map],
        mounted() {
            this.emitter.on('highlightFitterOnMap', fitter => {
                this.viewFitter(fitter.id, fitter.latitude, fitter.longitude);
            });
        },
        methods: {
            onTilesLoaded() {
                if (!this.garageFitters || !this.garageFitters[0]) {
                    return false;
                }

                if (this.view === 'fitters' || this.view === 'fittedNationally') {
                    this.setBounds();
                } else {
                    this.calculateDirections(this.garageFitters[0].latitude, this.garageFitters[0].longitude, this.center)
                }
            }
        }
    }
</script>

<style lang="scss">
    .mapdiv {
        border-radius: 0.25rem;
        box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 8%) !important;
    }
</style>